import type { ReactElement } from "react";

import { signal } from "@/motion/signals";

import type { WorkspaceTodo } from "./api";
import { WorkspaceTodoList } from "./WorkspaceTodoList";

export function WorkspaceProgressCard({
  status,
  progress,
  todos,
}: {
  status: "processing" | "working";
  progress?: string;
  todos?: WorkspaceTodo[];
}): ReactElement {
  const working = status === "working";

  return (
    <div
      role="status"
      aria-label={progress ?? "Update in progress"}
      className="flex max-w-[94%] items-start gap-2.5"
    >
      <span
        className={`${signal.wait} mt-[0.55rem] size-1.5 shrink-0 rounded-full bg-[#315d54]`}
        aria-hidden="true"
      />
      <div className="min-w-0 pt-0.5">
        {progress ? (
          <p
            key={progress}
            className={`${signal.waitCopy} text-sm leading-6 text-[#6d7169]`}
          >
            {progress}
            <span className={signal.waitEllipsis} aria-hidden="true">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </p>
        ) : null}
        {working ? (
          <p className="mt-0.5 text-xs leading-5 text-[#96988f]">
            You can leave this page. This workspace will update when it’s ready.
          </p>
        ) : null}
      </div>
      {todos && todos.length > 0 ? <WorkspaceTodoList todos={todos} /> : null}
    </div>
  );
}
